import type { DropTargetDropEvent } from '@affine/component';
import type { AffineDNDData } from '@affine/core/types/dnd';

export type NavigationPanelDragSelectionItem = NonNullable<
  AffineDNDData['draggable']['selection']
>['items'][number];

export function getNavigationPanelDragSelection(
  data: DropTargetDropEvent<AffineDNDData>
): NavigationPanelDragSelectionItem[] {
  return getNavigationPanelDragSelectionFromDraggable(data.source.data);
}

export function getNavigationPanelDragSelectionFromDraggable(
  data: AffineDNDData['draggable']
): NavigationPanelDragSelectionItem[] {
  const selectedItems = data.selection?.items;
  if (selectedItems?.length) {
    return selectedItems.filter(
      item => item.entity.type === 'doc' || item.entity.type === 'folder'
    );
  }

  const entity = data.entity;
  if (entity?.type === 'doc' || entity?.type === 'folder') {
    return [
      {
        entity,
        docTrash: data.docTrash,
        folderTrash: data.folderTrash,
        from: data.from,
      },
    ];
  }

  return [];
}

export function withNavigationPanelDragSelectionItem(
  data: DropTargetDropEvent<AffineDNDData>,
  item: NavigationPanelDragSelectionItem
): DropTargetDropEvent<AffineDNDData> {
  return {
    ...data,
    source: {
      ...data.source,
      data: {
        ...data.source.data,
        entity: item.entity,
        docTrash: item.docTrash,
        folderTrash: item.folderTrash,
        from: item.from,
        selection: undefined,
      },
    },
  };
}

export function forEachNavigationPanelDragSelectionItem(
  data: DropTargetDropEvent<AffineDNDData>,
  callback: (itemData: DropTargetDropEvent<AffineDNDData>) => void
): void {
  for (const item of getNavigationPanelDragSelection(data)) {
    callback(withNavigationPanelDragSelectionItem(data, item));
  }
}
